import { useIonToast } from '@ionic/react'

export const useToast = () => {
  return useIonToast()
}
